export const registerEn = {
    sjhm:"Mobile phone:",
    qsrsjhm:"Please enter your mobile phone number",
    yzm:"Verification code:",
    qsryzm:"Please enter the verification code",
    fsyzm:"Send verification code",
    jsts:"Resend in seconds",
    zcxy:"Agreement on registration of CCT product testing and certification platform",
    yxzc:"Registered mail",
    wxzc:"WeChat registered",
    nicheng:"Nickname:",
    nichengtishi:"Please enter your nickname",
    szmm:"Set password",
    zcsrma:"Enter the password again",
    chenggongtishi:"Congratulations to you! You have successfully registered as a member of CCTDC product testing and certification platform! If you encounter any problems, please contact the customer service of the platform in time!",
    dengluzhanghu:"Login account:",
    lijidenglu:"Login immediately"
}


// WEBPACK FOOTER //
// ./src/lang/home/register/indexEn.js